import axios from 'axios';
import {V1API} from "../../../_helpers/APIPath";
import {encode, decode} from "../../dataMagic";
import {populateStore, performNetworkCall, buildFormData} from "@/store/asyncHelper";


const keyList = {
    smsUpdate : 'AWARD_UPDATE',
    smsDelete : 'AWARD_DELETE'
};

const mutations = {};
const store = {};

populateStore(store, mutations, keyList, false);

export default {
    namespaced: true,

    state : {
        award:[],
        award_detail:{},

        submitLoading: false,
        submitError: false,
        submitSuccess: false,

        awardLoading: false,
        awardError: false,
       
        ...store
    },

    mutations : {
        ...mutations,

        SET_AWARD(state, award) {
            state.award = award;
        },

        SET_AWARD_DETAIL(state, detail) {
            state.award_detail = detail;
        },

        AWARD_LOADING (state, loading) {
            state.awardLoading = loading;
        },

        AWARD_ERROR (state, hasError) {
            state.awardError = hasError;
        },

        SUBMIT_LOADING (state, loading) {
            state.submitLoading = loading;
        },

        SUBMIT_ERROR (state, hasError) {
            state.submitError = hasError;
        },

        SUBMIT_SUCCESS (state, success) {
            state.submitSuccess = success;
        }
    },

    actions: {
        //Award
        async addAward ({commit, dispatch}, payload) {
            commit('AWARD_LOADING', true);
            commit('AWARD_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                },
            };

            try{
                let response = await axios.post(V1API.create_award, payload.award, config).then(result=>{
                    let data = result.data
                    return data
                });
                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAward')
                return response

            } catch (e) {
                commit('AWARD_ERROR', true);
            } finally {
                commit('AWARD_LOADING', false);
            }
        },

        async fetchAwardDetail ({ commit },payload) {
            commit('AWARD_LOADING', true);
            commit('AWARD_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.get_award_details + payload, config);
                let response = result.data.data
                commit('SET_SLIDER_DETAIL', response);

            } catch(error) {
                commit('AWARD_ERROR', true);
            } finally {
                commit('AWARD_LOADING', false);
            }
        },

        async fetchAward ({ commit }) {
            commit('AWARD_LOADING', true);
            commit('AWARD_ERROR', false);

            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try{
                let result = await axios.get(V1API.award_list, config);
                let response = result.data
                commit('SET_AWARD', response.data);

            } catch(error) {
                commit('AWARD_ERROR', true);
            } finally {
                commit('AWARD_LOADING', false);
            }
        },
    
        async updateAward ({commit, dispatch}, payload) {
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            try {
                let response = await axios.patch(V1API.update_award+payload.id, payload.award, config).then(result=>{
                    let data = result.data
                    return data
                });

                commit('SUBMIT_SUCCESS', true);
                dispatch ('fetchAward')
                return response

            } catch (e) {
                commit('AWARD_ERROR', true);
            } finally {
                commit('AWARD_LOADING', false);
            }
        },

        async deleteAward({commit, dispatch}, payload) {
            let config = {
                headers: {
                  Authorization: "Bearer " + localStorage.getItem("access_token"),
                }
            };

            let response = await axios.delete(V1API.award_delete + payload.delete, config).then(result=>{
                let data = result.data
                return data
            })
            
            dispatch ('fetchAward')
            return response
        }
    },

    getters: {}
}
